/**
 * Alert theme values.
 */
import { Components } from "@oui/system/components"
import { css } from "@oui/system"
import palettes from "../../palettes"

const base = css`
  background: ${palettes.tertiary.light};
`

const appearances: Components["Alert"]["appearances"] = {
  default: css`
    ${base};
  `,
  success: "",
  warning: "",
  danger: ""
}

export default { appearances }
